module.exports = __webpack_public_path__ + "static/img/09.cd158fb1.gif";